import useTLO from "./useTLO"

export default function usePortfolio(id) {
  return useTLO("portfolio", id)
}
